import { supabase } from '../supabase';

class ActivityLogService {
  /**
   * Log an activity to the unified activity_logs table
   */
  async logActivity(logData) {
    try {
      const { error } = await supabase.from('activity_logs').insert([
        {
          restaurant_id: logData.restaurant_id,
          user_id: logData.user_id,
          user_name: logData.user_name,
          user_role: logData.user_role,
          action_type: logData.action_type,
          action_name: logData.action_name,
          target_id: logData.target_id,
          target_name: logData.target_name,
          details: logData.details || {},
          description: logData.description,
          timestamp: new Date().toISOString(),
        },
      ]);

      if (error) throw error;
      return { success: true };
    } catch (error) {
      console.error('Error logging activity:', error);
      return { success: false, error: error.message };
    }
  }

  /**
   * Get unified activity logs for a restaurant
   */
  async getActivityLogs(restaurantId, page = 1, pageSize = 50) {
    try {
      const from = (page - 1) * pageSize;
      const to = from + pageSize - 1;

      const { data, error, count } = await supabase
        .from('activity_logs')
        .select('*', { count: 'exact' })
        .eq('restaurant_id', restaurantId)
        .order('timestamp', { ascending: false })
        .range(from, to);

      if (error) throw error;
      return { data, count, error: null };
    } catch (error) {
      return { data: null, error: error.message };
    }
  }
}

// Instantiate singleton
export const activityLogService = new ActivityLogService();

// Backwards-compatible bindings
export const logActivity = activityLogService.logActivity.bind(activityLogService);
export const getActivityLogs = activityLogService.getActivityLogs.bind(activityLogService);

export default activityLogService;
